import initPlayerDetail from './player-detail/index';
import initMyTeam from './my-team/my-team';
import initClaim from './claim/claim';
import statDetail from './stats/detail';

export {
  initPlayerDetail,
  statDetail,
  initMyTeam,
  initClaim,
};
